/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */
import axios from "axios";
import msal from "msal";
/* global document, Office */
const keyHexString = "pG3JjX8QriIeyfLwea5Ke/hamDIQq9sqKbZL0gdlRlI=";

/* global document, Office, Word */
const favDialog = document.getElementById("favDialog");
const comapnyDialog = document.getElementById("companyDialog");
const categoriesDialog = document.getElementById("categoriesDialog");
const selectComapny = document.getElementById("dropdown");
const selectCompanyBtn = document.getElementById("selectCompanyBtn");
const uploadBody = document.getElementById("upload-body");
const loginBody = document.getElementById("login-body");
const loginButton = document.getElementById("login-button");
let hostValue = "";
let usernameValue = "";
let passwordValue = "";
let comanyValue = "";
Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    // document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    document.getElementById("run").onclick = run;

    
    // var currentMessage = Office.context.mailbox.item;

    // const currentMessage = Office.context.mailbox.item;

    // // Retrieve message data
    // const subject = currentMessage.subject;
    // const sender = currentMessage.sender.displayName;
    // // ... other message properties

    // // Retrieve attachments
    // const attachments = currentMessage.attachments;

    // Generate .msg file content (use a library or service)
    
    // const msgFileContent = generateMsgFileContent({
    //   subject: subject,
    //   sender: sender,
    //   attachments: attachments,
    //   // ... other properties
    // });

    // Offer the .msg file for download
    // const blob = new Blob([msgFileContent], { type: "application/vnd.ms-outlook" });
    // const fileName = "message.msg"; // Desired filename
    // const msalConfig = {
    //   auth: {
    //     clientId: 'YOUR_CLIENT_ID',
    //     authority: 'https://login.microsoftonline.com/YOUR_TENANT_ID',
    //     redirectUri: 'https://localhost' // Redirect URI registered in Azure App Registration
    //   }
    // };
    
    // const msalInstance = new msal.PublicClientApplication(msalConfig);
    
    // // Define scopes and acquire token
    // const tokenRequest = {
    //   scopes: ['user.read', 'mail.read']
    // };
    
    // msalInstance.loginPopup(tokenRequest)
    //   .then(response => {
    //     const accessToken = response.accessToken;
        
    //     // Use the accessToken to make API request
    //     fetch('https://graph.microsoft.com/v1.0/me/messages/{message_id}/$value', {
    //       headers: {
    //         'Authorization': `Bearer ${accessToken}`
    //       }
    //     })
    //     .then(response => response.blob())
    //     .then(blob => {
    //       // Save the blob as .msg file
    //       const a = document.createElement('a');
    //       a.href = URL.createObjectURL(blob);
    //       a.download = 'email.msg';
    //       a.click();
    //     })
    //     .catch(error => console.error(error));
    //   })
    //   .catch(error => console.error(error));
    // const a = document.createElement("a");
    // a.href = URL.createObjectURL(blob);
    // a.download = fileName;
    // a.textContent = "Download Message as .msg";
    // document.body.appendChild(a);
    // var subject = currentMessage.subject;
    // var sender = currentMessage.sender.displayName;
    // var attachments = currentMessage.attachments;

    // var msgFileContent = {
    //     from: sender,
    //     subject: subject,
    //     attachments: attachments,

    // };

    // var blob = new Blob([msgFileContent], { type: "application/vnd.ms-outlook" });
    // var fileName = "message.msg"; // Desired filename

    // var a = document.createElement("a");
    // a.href = URL.createObjectURL(blob);
    // a.download = fileName;
    // a.textContent = "Download Message as .msg";
    // document.body.appendChild(a);
  }

  // function generateMsgFileContent(messageData) {
  //   // Create an empty .msg file array
  //   const buffer = require("buffer");
  //   const msgFileArray = [];

  //   // Start the .msg file with the required header
  //   msgFileArray.push(buffer.Buffer.from([0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1]));

  //   // ... Add more header data and properties based on the .msg file format specifications

  //   // Add the subject
  //   const subjectBytes = buffer.Buffer.from(`Subject: ${messageData.subject}\n`, "utf-8");
  //   msgFileArray.push(subjectBytes);

  //   // Add the sender
  //   const senderBytes = buffer.Buffer.from(`Sender: ${messageData.sender}\n`, "utf-8");
  //   msgFileArray.push(senderBytes);

  //   // ... Add more message properties as needed

  //   // Add attachments
  //   for (const attachment of messageData.attachments) {
  //     // Add attachment metadata, such as filename and type
  //     const attachmentMetadataBytes = buffer.Buffer.from(`Attachment: ${attachment.name}\n`, "utf-8");
  //     msgFileArray.push(attachmentMetadataBytes);

  //     // Add attachment content
  //     msgFileArray.push(attachment.content);
  //   }

  //   // Combine all the .msg file parts into a single Uint8Array
  //   const msgFileContent = new Uint8Array(buffer.Buffer.concat(msgFileArray));

  //   return msgFileContent;
  // }
var userdata = localStorage.getItem("Xplore");
  if (userdata === null) {
    uploadBody.style.display = "none";
    loginBody.style.display = "block";
 

  } else {
    // There is data stored under the key "username"

    const decryptedData = decrypt(userdata, keyHexString);
    hostValue = decryptedData.host;
    usernameValue = decryptedData.username;
    passwordValue = decryptedData.password;
    comanyValue = decryptedData.company;
    uploadBody.style.display = "block";
    loginBody.style.display = "none";
    

  }
});

export async function run() {
  const item = Office.context.mailbox.item;
  const button = document.getElementById("run");
  button.disabled = true;
  button.textContent = "Uploading";
  button.style.backgroundColor = "gray";
  // document.getElementById("error-message-header").textContent = "Uploading!";
  // document.getElementById("error-message").textContent = "Uploading File...";
  // favDialog.showModal();
  Office.context.mailbox.getCallbackTokenAsync( { isRest: true,asyncContext: "refreshToken"  }, function (tokenResults) {
    if (tokenResults.status === Office.AsyncResultStatus.Failed) {
      this.setState({ error: 'Failed to get rest api auth token' });
      document.getElementById("error-message-header").textContent = "Success!";
      document.getElementById("error-message").textContent = "Failed to get rest api auth token.";
      favDialog.showModal();
      button.disabled = false;
      button.textContent = "Upload";
      button.style.backgroundColor = "#04AA6D";
      return;
    }
    const apiId= getItemRestId()
    const apiUrl = Office.context.mailbox.restUrl + '/v2.0/me/messages/' + apiId + '/$value';
    console.log(apiUrl);
    try {
      fetch(apiUrl, {
        method: 'GET',
        headers: new Headers({
          Authorization: 'Bearer ' + tokenResults.value
        })
      }).then((response) => {
        response.blob().then((blob) => {
          console.log(blob);
          var file = new File([blob], 'outlook.eml', { type: 'eml' });
          var userdata = localStorage.getItem("Xplore");
          if (userdata === null) {
            uploadBody.style.display = "none";
            loginBody.style.display = "block";
          } else {
            // There is data stored under the key "username"
    
            const decryptedData = decrypt(userdata, keyHexString);
            hostValue = decryptedData.host;
            usernameValue = decryptedData.username;
            passwordValue = decryptedData.password;
            uploadBody.style.display = "block";
            loginBody.style.display = "none";
          }
          loginRequest(hostValue, usernameValue, passwordValue).then(
            (result) => {
              if (result.status === 200) {
                let data = result.data;
                let token = "";
                let company = comanyValue;
                for (const key in data) {
                  if (Object.hasOwnProperty.call(data, key)) {
                    if (key == "message") {
                      return;
                    }
                    const value = data[key];
                    // if (key == "company_users") {
                    //   for (const key2 in value[0]) {
                    //     if (Object.hasOwnProperty.call(data, key)) {
                    //       if (key2 == "company") {
                    //         company = value[0][key2];
                    //       }
                    //     }
                    //   }
                    // }
                    if (key == "token") {
                      for (const key2 in value) {
                        if (Object.hasOwnProperty.call(data, key)) {
                          if (key2 == "access") {
                            token = "Bearer " + value[key2];
                          }
                        }
                      }
                    }
                  }
                }
                uploadFileRequest(hostValue, file, company, token).then((uploadReslt) => {
                  if (uploadReslt.status === 200) {
                    indexFileRequest(hostValue, uploadReslt.data, company, token).then((indexReslt) => {
                      if (indexReslt.status === 200){
                        document.getElementById("error-message-header").textContent = "Success!";
                        document.getElementById("error-message").textContent = "File Uploaded Successfully.";
                        favDialog.showModal();
                        button.disabled = false;
                        button.textContent = "Upload";
                        button.style.backgroundColor = "#04AA6D";
                      }else{
                        document.getElementById("error-message-header").textContent = "Error!";
                        document.getElementById("error-message").textContent = indexReslt;
                        favDialog.showModal();
                        button.disabled = false;
                        button.textContent = "Upload";
                        button.style.backgroundColor = "#04AA6D";
                      }
                    });
                  } else {
                    document.getElementById("error-message-header").textContent = "Error!";
                    document.getElementById("error-message").textContent = uploadReslt;
                    favDialog.showModal();
                      button.disabled = false;
                      button.textContent = "Upload";
                      button.style.backgroundColor = "#04AA6D";
                  }
                });
              } else {
                document.getElementById("error-message-header").textContent = "Error!";
    
                document.getElementById("error-message").textContent = result;
                favDialog.showModal();
                button.disabled = false;
                button.textContent = "Upload";
                button.style.backgroundColor = "#04AA6D";
              }
            },
            (reason) => {
              document.getElementById("error-message").textContent = reason;
              favDialog.showModal();
              button.disabled = false;
              button.textContent = "Upload";
              button.style.backgroundColor = "#04AA6D";
            }
          );
        });
      });
    } catch (error) {
      document.getElementById("error-message").textContent = error;
      favDialog.showModal();
      button.disabled = false;
      button.textContent = "Upload";
      button.style.backgroundColor = "#04AA6D";
}
  });
  // Office.context.mailbox.getCallbackTokenAsync({ isRest: true }, function (result) {
  //   if (result.status === "succeeded") {
  //     const accessToken = result.value;
  //     console.log(result.value);
  //     // Step 2: Make API request
  //     // const messageId = getItemRestId();
  //     getCurrentItem(accessToken);
  //     // const messageId = Office.context.mailbox.item.itemId;
  //     // fetch(`https://graph.microsoft.com/v1.0/me/messages/${messageId}`, {
  //     //   headers: {
  //     //     'Authorization': accessToken
  //     //   }
  //     // })
  //     //   .then(response => {
  //     //     if (!response.ok) {
  //     //       throw new Error('Network response was not ok');
  //     //     }
  //     //     return response.json();
  //     //   })
  //     //   .then(emailData => {
  //     //     // Proceed with converting email data to .msg format
  //     //     // ...
  //     //   })
  //     //   .catch(error => {
  //     //     // Handle API request or conversion error
  //     //   });
  //     // fetch(`https://graph.microsoft.com/v1.0/me/messages/${messageId}`, {
  //     //   headers: {
  //     //     'Authorization': accessToken // No need to prepend 'Bearer ' here
  //     //   }
  //     // })
  //     // .then(response => {
  //     //   if (!response.ok) {
  //     //     throw new Error('Network response was not ok');
  //     //   }
  //     //   return response.json();
  //     // })
  //     // .then(emailData => {
  //     //   // Step 3: Convert email data to .msg format (you would need to implement this)
  //     //   const msgContent = convertToMsgFormat(emailData);
        
  //     //   // Step 4: Create a Blob and download link
  //     //   const blob = new Blob([msgContent], { type: 'application/octet-stream' });
  //     //   const a = document.createElement('a');
  //     //   a.href = URL.createObjectURL(blob);
  //     //   a.download = 'email.msg';
  //     //   a.click();
  //     // })
  //     // .catch(error => console.error(error));
  //   }
  // });
  // console.log(\);  document.getElementById("item-subject").innerHTML = "<b>Subject:</b> <br/>" + item.attachments;

  /**
   * Insert your Outlook code here
   */
  // item.attachments
  // await getCurrentFile();
}
// function downloadViaRest() {



// }
// async function getCurrentFile() {
//   await Office.context.mailbox.getFileAsync(Office.FileType.Pdf, async function (result) {
//     if (result.status == "succeeded") {
//       var myFile = result.value;
//       var sliceCount = myFile.sliceCount;
//       let fileContent = new Uint8Array();

//       for (let i = 0; i < sliceCount; i++) {
//         const sliceResult = await new Promise((resolve) => {
//           myFile.getSliceAsync(i, (result) => {
//             resolve(result);
//           });
//         });

//         if (sliceResult.status === "succeeded") {
//           const slice = sliceResult.value.data;
//           const sliceArray = new Uint8Array(slice);
//           fileContent = concatenateArrays(fileContent, sliceArray);
//         } else {
//           document.getElementById("error-message-header").textContent = "Error!";
//           document.getElementById("error-message").textContent = "Error in convert file!";
//           favDialog.showModal();
//           return;
//         }
//       }

//       const fileUrl = Office.context.document.url.split("\\");

//       const file = new File([fileContent], fileUrl[fileUrl.length - 1], { type: "xlsx" });
      // var userdata = localStorage.getItem("Xplore");
      // if (userdata === null) {
      //   // There is no data stored under the key "username"
      //   // favDialog.showModal();
      //   uploadBody.style.display = "none";
      //   loginBody.style.display = "block";
      // } else {
      //   // There is data stored under the key "username"

      //   const decryptedData = decrypt(userdata, keyHexString);
      //   hostValue = decryptedData.host;
      //   usernameValue = decryptedData.username;
      //   passwordValue = decryptedData.password;
      //   uploadBody.style.display = "block";
      //   loginBody.style.display = "none";
      // }
      // loginRequest(hostValue, usernameValue, passwordValue).then(
      //   (result) => {
      //     if (result.status === 200) {
      //       let data = result.data;
      //       let token = "";
      //       let company = "";
      //       for (const key in data) {
      //         if (Object.hasOwnProperty.call(data, key)) {
      //           if (key == "message") {
      //             return;
      //           }
      //           const value = data[key];
      //           if (key == "company_users") {
      //             for (const key2 in value[0]) {
      //               if (Object.hasOwnProperty.call(data, key)) {
      //                 if (key2 == "company") {
      //                   company = value[0][key2];
      //                 }
      //               }
      //             }
      //           }
      //           if (key == "token") {
      //             for (const key2 in value) {
      //               if (Object.hasOwnProperty.call(data, key)) {
      //                 if (key2 == "access") {
      //                   token = "Bearer " + value[key2];
      //                 }
      //               }
      //             }
      //           }
      //         }
      //       }
      //       uploadFileRequest(hostValue, file, company, token).then((uploadReslt) => {
      //         if (uploadReslt.status === 200) {
      //           indexFileRequest(hostValue, uploadReslt.data, company, token).then((indexReslt) => {
      //             if (indexReslt.status === 200){
      //               document.getElementById("error-message-header").textContent = "Success!";
      //               document.getElementById("error-message").textContent = "File Uploaded Successfully.";
      //               favDialog.showModal();
      //             }else{
      //               document.getElementById("error-message-header").textContent = "Error!";
      //               document.getElementById("error-message").textContent = indexReslt;
      //               favDialog.showModal();
      //             }
      //           });
      //         } else {
      //           document.getElementById("error-message-header").textContent = "Error!";
      //           document.getElementById("error-message").textContent = uploadReslt;
      //           favDialog.showModal();
      //         }
      //       });
      //     } else {
      //       document.getElementById("error-message-header").textContent = "Error!";

      //       document.getElementById("error-message").textContent = result;
      //       favDialog.showModal();
      //     }
      //   },
      //   (reason) => {
      //     document.getElementById("error-message").textContent = reason;
      //     favDialog.showModal();
      //   }
      // );
//       myFile.closeAsync();
//     } else {
//       document.getElementById("error-message-header").textContent = "Error!";

//       document.getElementById("error-message").textContent = result;
//       favDialog.showModal();
//     }
//   });
// }
function getItemRestId() {
  if (Office.context.mailbox.diagnostics.hostName === 'OutlookIOS') {
    // itemId is already REST-formatted.
    return Office.context.mailbox.item.itemId;
  } else {
    // Convert to an item ID for API v2.0.
    return Office.context.mailbox.convertToRestId(
      Office.context.mailbox.item.itemId,
      Office.MailboxEnums.RestVersion.v2_0
    );
  }
}
function getCurrentItem(accessToken) {
  // Get the item's REST ID.
  const itemId = getItemRestId();

  // Construct the REST URL to the current item.
  // Details for formatting the URL can be found at
  // https://learn.microsoft.com/previous-versions/office/office-365-api/api/version-2.0/mail-rest-operations#get-messages.
  const getMessageUrl = Office.context.mailbox.restUrl +
    '/v2.0/me/messages/' + itemId;

  $.ajax({
    url: getMessageUrl,
    dataType: 'json',
    headers: { 'Authorization': 'Bearer ' + accessToken }
  }).done(function(item){
    // Message is passed in `item`.
    const subject = item.Subject;
  }).fail(function(error){
    // Handle error.
  });
}
// function getCurrentItem(accessToken) {
//   // Get the item's REST ID.
//   const itemId = getItemRestId();

//   // Construct the REST URL to the current item.
//   // Details for formatting the URL can be found at
//   // https://learn.microsoft.com/previous-versions/office/office-365-api/api/version-2.0/mail-rest-operations#get-messages.
//   const getMessageUrl = Office.context.mailbox.restUrl + "/v2.0/me/messages/" + itemId;

//   $.ajax({
//     url: getMessageUrl,
//     dataType: "json",
//     headers: { Authorization: "Bearer " + accessToken },
//   })
//     .done(function (item) {
//       // Message is passed in `item`.
//       const subject = item.Subject;
//       console.log(subject,'uyyyyyyyyyyyyy');
//     })
//     .fail(function (error) {
//       // Handle error.
//     });
// }
// function concatenateArrays(arr1, arr2) {
//   var result = new Uint8Array(arr1.length + arr2.length);
//   result.set(arr1);
//   result.set(arr2, arr1.length);
//   return result;
// }
async function loginRequest(host, username, password) {
  try {
    const data = {
      username: username,
      password: password,
    };
    const request = await axios.post(`${host}/users/login`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return request;
  } catch (error) {
    return "Unable to login with provided credentials.";
  }
}
async function getCategories(host, company, token) {
  try {
    const request = await axios.get(`${host}/search/attachments/categories`, {
      headers: {
        "Content-Type": "application/json",
        company: company,
        Authorization: token,
      },
    });
    return request;
  } catch (error) {
    return error;
  }
}
async function uploadFileRequest(host, file, company, token) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const request = await axios.post(`${host}/index/upload`, formData, {
      headers: {
        "Content-Type": "application/json",
        company: company,
        Authorization: token,
      },
    });
    return request;
  } catch (error) {
    return error;
  }
}
async function indexFileRequest(host, keys, company, token) {
  try {
    const request = await axios.post(`${host}/index/index`, keys, {
      headers: {
        "Content-Type": "application/json",
        company: company,
        Authorization: token,
      },
    });

    return request;
  } catch (error) {
    return error;
  }
}
loginButton.addEventListener("click", () => {
  const hostnameText = document.getElementById("hostText").value;
  const usernameText = document.getElementById("usernameText").value;
  const passwordText = document.getElementById("passwordText").value;
  if (!isStringValid(hostnameText) || !isStringValid(usernameText) || !isStringValid(passwordText)) {
    document.getElementById("error-message-header").textContent = "Error!";

    document.getElementById("error-message").textContent = "Please Fill Empty Fields";
    favDialog.showModal();
  } else {
    loginRequest(hostnameText, usernameText, passwordText).then(
      (result) => {
        if (result.status === 200) {
          // const userdata = { host: hostnameText, username: usernameText, password: passwordText };
          // const encryptedData = encrypt(userdata, keyHexString);
          // localStorage.setItem("Xplore", encryptedData);
          // uploadBody.style.display = "block";
          // loginBody.style.display = "none";
          hostValue = hostnameText;
          usernameValue = usernameText;
          passwordValue = passwordText;
          if(result.data.company_users){
            let companyID;
            if(result.data.company_users.length > 1){
              // var dropdown = document.getElementById("dropdown");
              // for (const company of result.data.company_users) {
              //   const optionElement = document.createElement("option");
              //   optionElement.value = company.company;
              //   optionElement.textContent = company.company_name;
              //   dropdown.appendChild(optionElement);
              // }
              // comapnyDialog.showModal();
              // companyID = dropdown.options[dropdown.selectedIndex].value;
              openDialog(result.data.company_users);
            }else{
              companyID = result.data.company_users[0].company;
              const userdata = { host: hostValue, username: usernameValue, password: passwordValue, company:companyID };
              const encryptedData = encrypt(userdata, keyHexString);
              localStorage.setItem("Xplore", encryptedData);
              uploadBody.style.display = "block";
              loginBody.style.display = "none";
              location.reload();

            }
            

          }else{
            document.getElementById("error-message-header").textContent = "Error!";

            document.getElementById("error-message").textContent = "User not assigned to any company";
            favDialog.showModal();
          }
        } else {
          document.getElementById("error-message-header").textContent = "Error!";

          document.getElementById("error-message").textContent = result;
          favDialog.showModal();
        }
      },
      (reason) => {
        document.getElementById("error-message-header").textContent = "Error!";

        document.getElementById("error-message").textContent = reason;
        favDialog.showModal();
      }
    );
  }
});
function openDialog(array) {
  var dialog = document.getElementById("dialog");
  var dropdown = document.getElementById("dropdown");
  dialog.showModal();
  // Clear existing options
  dropdown.innerHTML = "";

  // Populate dropdown with values from the array
  for (var i = 0; i < array.length; i++) {
    var option = document.createElement("option");
    option.value = array[i].company;
    option.textContent = array[i].company_name;
    // option.text = array[i];
    dropdown.add(option);
  }

  dialog.style.display = "block";
}
var loginButtons = document.getElementById("loginButtons");
loginButtons.addEventListener("click", () => {
  var dropdown = document.getElementById("dropdown");
  var selectedValue = dropdown.options[dropdown.selectedIndex].value;
  const userdata = { host: hostValue, username: usernameValue, password: passwordValue, company:selectedValue };
  const encryptedData = encrypt(userdata, keyHexString);
  localStorage.setItem("Xplore", encryptedData);
  var dialog = document.getElementById("dialog");
  dialog.style.display = "none";
  uploadBody.style.display = "block";
  loginBody.style.display = "none";
  location.reload();

 
});
function isStringValid(str) {
  return typeof str === "string" && str.trim() !== "";
}

function encrypt(o, salt) {
  o = JSON.stringify(o).split("");
  for (var i = 0, l = o.length; i < l; i++)
    if (o[i] == "{") o[i] = "}";
    else if (o[i] == "}") o[i] = "{";
  return encodeURI(salt + o.join(""));
}

function decrypt(o, salt) {
  o = decodeURI(o);
  if (salt && o.indexOf(salt) != 0) throw new Error("object cannot be decrypted");
  o = o.substring(salt.length).split("");
  for (var i = 0, l = o.length; i < l; i++)
    if (o[i] == "{") o[i] = "}";
    else if (o[i] == "}") o[i] = "{";
  return JSON.parse(o.join(""));
}
